module.exports = __webpack_public_path__ + "img/app_download.fe3cbecc.png";